module.exports = __webpack_public_path__ + "img/bg-hasprize.0a89a96c.jpg";